import {authStore} from '@yourcoach/shared/api/auth';
import {currentUserStore} from '@yourcoach/shared/api/user';
import {logger} from '@yourcoach/shared/utils/logger';
import {storage} from '@yourcoach/shared/utils/storage';

import localAppStore from '@src/context/appStore';
import {routerPath} from '@src/routes/path';

/**
 * @deprecated Figure out why this is needed and remove it
 */
export const useSetReturnPath = () => {
  const location = window.location;

  const rootPath = routerPath.$buildPath({});
  const yourSpacePath = routerPath.yourSpace.$buildPath({});
  const loginPath = routerPath.login.$buildPath({});

  if (
    location.pathname !== rootPath &&
    location.pathname !== yourSpacePath &&
    location.pathname !== loginPath
  ) {
    const path = `${location.pathname}${location.search}`;

    storage.setItem('returnPath', path);

    return () => {
      localAppStore.setReturnPath(path);
    };
  } else {
    storage.setItem('returnPath', '');

    return () => {
      localAppStore.setReturnPath('');
    };
  }
};

export const useIsAuth = (fnTrue = () => {}, fnFalse = () => {}) => {
  const isAuth = async (fnTrueIn = () => {}, fnFalseIn = () => {}) => {
    try {
      const sessionIsActive = await authStore.sessionIsActive();
      const userExists = await currentUserStore.userExists();

      if (sessionIsActive && userExists) {
        localAppStore!.setIsAuth(true);

        fnTrueIn();
      } else {
        localAppStore!.setIsAuth(false);
        fnFalseIn();
      }
    } catch (error) {
      logger.error(error);
    }
  };

  return async () => await isAuth(fnTrue, fnFalse);
};
